export const getSmsConsentMessage = (
  buttonName: "Pay" | "Send Request" | "Reserve",
  operatorName: string,
) =>
  `By clicking "${buttonName}" you agree to receive order updates from ${operatorName} via SMS. Message frequency varies. Messages & data rates may apply. We will never share your personal information with third parties for marketing purposes. You can opt out of receiving text messages at any time by replying STOP.`;
